export function selectScopedResources<T>(
  resources: T[],
  getId: (resource: T) => string,
  scopedInstance: boolean,
  fixedOrganizationId: string | undefined,
): T[] {
  if (!scopedInstance || !fixedOrganizationId) {
    return resources
  }

  const exactMatches = resources.filter(
    (resource) => getId(resource) === fixedOrganizationId,
  )
  return exactMatches.length > 0 ? exactMatches : resources
}
